/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { MealFeedbackRequest } from "../models/MealFeedbackRequest";
import type { MessageOnlyResponse } from "../models/MessageOnlyResponse";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class MealFeedbackService {
  /**
   * Submit Meal Feedback
   * Submit feedback for a specific meal.
   * @param xUserId
   * @param requestBody
   * @returns MessageOnlyResponse Successful Response
   * @throws ApiError
   */
  public static submitMealFeedbackApiV1MealsFeedbackPost(
    xUserId: string,
    requestBody: MealFeedbackRequest,
  ): CancelablePromise<MessageOnlyResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/meals/feedback",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
